import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Calendar, X } from "lucide-react";
import { useTranslation } from "react-i18next";
import { motion, AnimatePresence } from "framer-motion";

const FloatingCTA = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const location = useLocation();

  // Don't show on Performance Lab page (already has booking) or Contact
  const hiddenRoutes = ["/performance-lab", "/contact"];
  const isHidden = hiddenRoutes.some(r => location.pathname.startsWith(r));

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 600);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (isHidden || dismissed) return null;

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: "spring", stiffness: 300, damping: 30 }}
          className="fixed bottom-6 right-6 z-40 flex items-center gap-2"
        >
          <Link
            to="/performance-lab#booking"
            onClick={() => {
              const el = document.getElementById("booking");
              if (el && window.location.pathname === "/performance-lab") {
                el.scrollIntoView({ behavior: "smooth", block: "start" });
              }
            }}
            className="flex items-center gap-2 px-5 py-3 bg-primary text-primary-foreground font-bold text-xs tracking-widest rounded-sm shadow-lg hover:bg-primary/90 transition-all hover:shadow-xl"
          >
            <Calendar className="w-4 h-4" />
            {t("nav.bookSession")}
          </Link>
          <button
            onClick={() => setDismissed(true)}
            className="p-1.5 bg-card border border-border rounded-sm text-muted-foreground hover:text-foreground transition-colors shadow-lg"
            aria-label="Dismiss"
          >
            <X className="w-3.5 h-3.5" />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default FloatingCTA;
